<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div
            class="col-12 aos-init aos-animate content mx-auto"
            data-aos="fade-up"
            data-aos-delay="100"
        >
		<div class="titulo-pagina mb-10 text-lg-left text-sm-center">
                <span>PERFIL DE </span><span class="text-uppercase">{{client.codigoRol}}</span>
            </div>
            <div class="card-femsa d-none d-sm-block">
                <div
                    class="card-body row justify-content-between align-items-center py-6 px-8"
                >
                    <div class="col-4 col-lg-4 d-none d-sm-block">
                        <div class="card-femsa-titulo">NOMBRE EMPRESA</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.nombreEmpresa }}
                        </div>
                    </div>
                    <div class="col-4 col-lg-2 d-none d-sm-block">
                        <div class="card-femsa-titulo">RUT EMPRESA</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.rutEmpresa }}-{{ client.rutEmpresaDv }}
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 mt-5 mt-lg-0 d-none d-sm-block">
                        <div class="card-femsa-titulo">CORREO CORPORATIVO</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.email }}
                        </div>
                    </div>

                    <div class="col-12 col-lg-3 mt-5 mt-lg-0 total-deuda">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-6 border-right">
                                <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15">DEUDA TOTAL</div>
                                <div class="total-deuda-monto mt-1 fs-15">
                                    {{ deudaTotal | currency }}
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15 d-flex justify-content-center">Saldo disponible <img class="info-Img" src="/media/img/infoImg.png" data-toggle="tooltip" title="Este saldo representa el dinero real que tienes a tu disposición para gastar o retirar en un momento específico."></div>
                                <div class="total-deuda-monto mt-1 fs-15">
                                    {{ saldoDisponible | currency }}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-block d-sm-none total-deuda">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6 border-right">
                        <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15">DEUDA TOTAL</div>
                        <div class="total-deuda-monto mt-1 fs-15">
                            {{ deudaTotal | currency }}
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15 d-flex justify-content-center">Saldo disponible <img class="info-Img" src="/media/img/infoImg.png" data-toggle="tooltip" title="Este saldo representa el dinero real que tienes a tu disposición para gastar o retirar en un momento específico."></div>
                        <div class="total-deuda-monto mt-1 fs-15">
                            {{ saldoDisponible | currency }}
                            
                        </div>
                    </div>
                </div>
            </div>

			<div class="titulo-pagina mt-10 mb-10 text-lg-left text-sm-center">
                <span>PEDIDOS </span><span>A PAGAR</span>
            </div>
          <b-overlay :show="loading" varant="white" rounded="sm">
           
          <template v-for="(item, i) in details" v-show="loading==true">
          <div v-bind:key="i" class="card card-list card-row d-flex flex-row">
            <div class="d-flex justify-content-between align-items-center d-content-full">
              <div class="form-group">
                <label for="inputFn">Pedido Nº</label>  
                <span id="inputFn">{{item.numeroDocumento}}</span>
              </div>
              <div class="form-group">
                <label for="inputDateLast">Fecha Pedido</label>  
                <span id="inputDateLast" class="text-danger"><i class="fa fa-times-circle "></i> {{item.fechaEmision | formatDate}}</span>
              </div>
              
              <div class="form-group d-flex flex-column align-items-end">
                <label for="inputMount" class="justify-content-end">monto total</label>  
                <span id="inputMount" class="justify-content-end text-right">{{item.monto | currency}}</span>
              </div>
              <div class="d-none hide form-group">
                <label for="inputCredited" class="justify-content-end">abonado</label>  
                <span id="inputCredited" class="justify-content-end text-right">{{item.abonado | currency}}</span>
              </div>
              <div class="d-none hide form-group">
                <label for="inputCredit" class="credit">
                  <!--div class="custom-control custom-switch d-flex flex-row align-self-end">
                    <b-form-checkbox v-model="item.permiteAbonar" class="xcustom-control-input" :disabled="!item.seleccionado"></b-form-checkbox>
                    <label class="custom-control-label" for="customSwitch1">Abonar</label>
                  </div-->
                  Monto a Pagar
                </label>  
                <money v-model="item.saldo" v-bind="money" class="form-control" disabled></money>
              </div>
            </div>
          </div>
          </template>
          
          <div class="card card-list card-total card-row d-flex flex-row align-items-center justify-content-end mb-4">
            <label>Total a pagar</label>
            <h4 class="m-0 pl-5">{{ordenPago.monto|currency}}</h4>
          </div>
          </b-overlay>
          </div>
		 <div
            class="contenedor-medios-de-pago d-flex flex-column justify-content-center"
        >
            <div class="d-flex justify-content-center mb-4">
                <di class="d-flex badge-femsa badge-azul-oscuro">
                    <div>TOTAL A PAGAR</div>
                    <div class="ml-5 font-weight-bold">
                        {{ ordenPago.monto | currency }}
                    </div>
                </di>
            </div>

            <div
                class="d-none card-bancos contenedor-bancos row justify-content-center"
            >
                <template v-for="(item, x) in methods">
                    <div v-bind:key="x + '-pay'">
                        <selectable-plan
                            :plan-codigo="item.codigo"
                            v-model="codigoMedioPago"
                        ></selectable-plan>
                        <span>{{item.codigo}}</span>
                    </div>
                    
                </template>
            </div>
            <form
                id="irapagar"
                name="irapagar"
                method="post"
                :action="order.payUrl"
            >
                <input
                    type="hidden"
                    name="guidTransaccion"
                    :value="order.guidTransaccion"
                />
                <input
                    type="hidden"
                    name="idEntidadRecaudadora"
                    :value="order.idEntidad"
                />
                <input
                    type="hidden"
                    name="codigoAplicacion"
                    :value="order.codigoAplicacion"
                />
                <input type="hidden" name="rutCliente" :value="rutCliente" />
                <input type="hidden" name="monto" :value="order.monto" />
            </form>
            <div class="d-sm-flex justify-content-center d-none d-sm-block">
                <button
                    v-on:click.prevent="processOrder()"
                    :disabled="ordenPago.monto == 0"
                    class="btn-second-femsa w-200px mr-10"
                >
                    Pagar
                </button>
            </div>

            <div class="d-block d-sm-none">
                <button
                    v-on:click.prevent="processOrder()"
                   :disabled="ordenPago.monto == 0"
                    class="btn-second-femsa w-100"
                >
                    Pagar
                </button>
            </div>
        </div>
    </div>
    <!--end::Dashboard-->
</template>


<script>

import { mapState } from "vuex";
import {LOGIN_PAGADOR} from "@/core/services/store/auth.module"; 
import { GET_METHODS, PROCESS_ORDER_DOCUMENTS, GET_ORDER_TOKEN, GET_DETAILS } from "@/core/services/store/payment.module";
import { GET_BALANCES } from "@/core/services/store/client.module";
import SelectablePlan from '@/view/content/widgets/payments/PaymentMethods.vue'
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {Money} from 'v-money'
import { validationMixin } from "vuelidate";
import {
  minLength
} from "vuelidate/lib/validators";

import moment from 'moment'
moment.locale( 'es' );

export default {
  mixins: [validationMixin],
  name: "dashboard",
  components: {Money, SelectablePlan},
  data() {
    return {
      page: 1,
      perPage: 20,
      selected: [],
      loading:true,
      menu2:false,
      menu1:false,
      hasta: null,
      desde:null,
      sucursal:"",
      codigoMedioPago: '',
      id:'',
      order:{},
      form: {
        documento: "",
        
        desde: "",
        hasta: ""
      },
      deudaTotal:0,
      saldoDisponible:0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      },
      json_fields: {
          "Documento": "numeroDocumento",
          "Monto": "monto",
          "Abonado": "abonado",
          "Saldo": "saldo",
          "Sucursal": "sucursal",
          "Vencimiento": "fechaVencimiento"
        },
    };
  },
  validations: {
    form: {
      documento: {
        minLength: minLength(3)
      },
      desde: {
        
      },
      hasta: {

      }
    }
  },
  mounted () {
    this.id = this.$route.params.token;
    this.autenticarPagador(this.id);
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        documento: null,
        sucursal: null,
        desde: null,
        hasta: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    autenticarPagador(params = null) {
      this.$Progress.start();
      this.$store
          .dispatch(LOGIN_PAGADOR, params)
          .then(()=>{
            this.getOrder(params);
            this.getDocuments(params);
            //this.getMethods();
            this.getBalances();
            this.$Progress.finish(), this.loading = false});
    },
    getOrder(params = null) {
      this.$Progress.start();
      this.$store
          .dispatch(GET_ORDER_TOKEN, params)
          .then((response)=>{
            this.deudaTotal = response.monto,
            this.$Progress.finish(), this.loading = false});
    },
    getDocuments(params = null) {
      this.$Progress.start();
      this.$store
          .dispatch(GET_DETAILS, params)
          .then((response)=>{
            console.log(JSON.stringify(response));
            this.$Progress.finish(), this.loading = false});
    },
    getBalances(params = null) {
            this.$Progress.start();
            this.$store
                .dispatch(GET_BALANCES, params)
                .then((response) => {
                    (this.saldoDisponible = response.totalSaldoAFavor),
                        this.$Progress.finish(),
                        (this.loading = false);
                })
                .catch(function () {
                    this.$Progress.finish(), (this.loading = false);
                });
        },
    getMethods() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_METHODS)
          .then(()=>{this.$Progress.finish()});
    },
    processOrder() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const t = this;
      this.$store
          .dispatch(PROCESS_ORDER_DOCUMENTS, {"token":this.id,"codigoMedioPago":this.codigoMedioPago, "Detalles":this.documents})
          .then(function(response){
            t.order = response;
            t.$router.push({ name: "confirm-order-external-pay", params: { codigo: response.tokenOrden }  });
            /*setTimeout(function()
              {
                if(t.order.nuevaVentana){
                  var left = (screen.width/2)-(800/2);
                  var top = (screen.height/2)-(600/2);
                  window.open('', 'formpopup', 'width=800,height=600,resizeable,scrollbars, top='+top+', left='+left);
                  document.getElementById("irapagar").target = 'formpopup';
                }
                document.getElementById("irapagar").submit();
              }, 10);*/
          });
    },
    onUpdatePay(activePay){
      this.codigoMedioPago = activePay;
    },
    estiloItem(item){
      const hoy = new Date();
      var date1 = moment(hoy).format("yyyy-mm-dd")
      var date2 = moment(item.fechaVencimiento).format("yyyy-mm-dd")
      if(moment(date1).isBefore(date2)){
        return "text-success";
      } else {
        return "text-danger";
      }
    }
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    visiblePages () {
      return this.documents.slice((this.page - 1)* this.perPage, this.page* this.perPage)
    },
    selectAll: {
      get() {
        if (this.documents && this.documents.length > 0) { // A users array exists with at least one item
          let allChecked = true;

          for (const user of this.documents) {
            if (!this.selected.includes(user.id)) {
              allChecked = false; // If even one is not included in array
            }
            
            // Break out of loop if mismatch already found
            if(!allChecked) break;
          }

          return allChecked;
        }

        return false;
      },
      set(value) {
        const checked = [];
          this.documents.forEach((user) => {
            checked.push(user.id);
            user.seleccionado = value
          });

        this.selected = checked;
      }
    },
    ...mapState({
      ordenPago : state => state.payment.order,
      details : state => state.payment.details,
	  balances: (state) => state.client.balances,
      documents : state => state.client.documents,
      sucursales : state => state.client.branchs,
      methods : state => state.payment.methods,
      errors: state => state.errors,
      client: state => state.auth.user,
      totalSumm: function(){
        return this.documents.filter(item => item.seleccionado).reduce(function(total, item){

          return total + (item.saldo); 
        },0);
      }, 
      totalDeuda: function(){
        return this.documents.reduce(function(total, item){

          return total + (item.monto - item.abonado); 
        },0);
      },
      rutCliente: function(){
        return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
      },  
      computedDateFormattedMomentjs () {
        return this.desde ? moment(this.desde).format('DD/MM/yyyy') : ''
      },
      computedDateFormattedMomentjs2 () {
        return this.hasta ? moment(this.hasta).format('DD/MM/yyyy') : ''
      } 
    })
  }
};
</script>
<style>
.custom-checkbox label {
    margin-top: 5px;
    display: block;
}
.custom-control-label::before {
    position: absolute;
    top: 0rem !important;
}
.custom-control-label::after {
    top: 0rem !important;
}
.b-form-datepicker {
    min-width: 130px;
}
.b-form-datepicker label {
    padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full {
    width: 100%;
}
</style>
